import React from 'react';
import { Route } from 'react-router-dom';

import BreadcrumbsItem from './BreadcrumbsItem';

const Breadcrumbs = () => <Route path="/:path" component={BreadcrumbsItem} />;

export default Breadcrumbs;
